import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
//import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
//import moment from 'moment';
import * as RestService from '../../services/eisRest';





  const CodeModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    
    const [selectedRecord, setSelectedRecord] = useState();
    
    
    const [codeListOptions, setCodeListOptions] = useState([]);  
    const [code, setCode] = useState([]);  
    const [codeList, setCodeList] = useState('');  
    const [openAlertDialog, setOpenAlertDialog] = useState(false);    
    
    const dialogRef = createRef();
  

  
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])


    useEffect(() => {
      setCodeList(props.codeList);
      if(props.codeList!=''){
        formik.setFieldValue("codeList",props.codeList); 
      }
    }, [props.codeList])

    
    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('company/getCompanyCode?id='+props.selectedRecord, null)
      .then((data) => {          
           setCode(data);         
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=companyCode&id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    }
    

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
  //    code.entityId=props.entityId;
    //  code.bankId=values.bankId;
    //  code.currency=values.currency;
    //  code.departmentId=values.departmentId;
     // code.iban=values.iban;
      code.codeList = values.codeList;
      code.code = values.code;      
      code.description = values.description;     
     
      RestService.callAnyApi(url, code)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };


    useEffect(() => {
      RestService.callAnyApi('company/getCompanyCodeListOptions?only='+codeList, null)
      .then((data) => { 
        
        data.map(function(item,i){
          item.label = t('general.label.'+item.label);
        });
        setCodeListOptions(data);
        })
      .catch((error) => {});      
    }, []);

    
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    

        codeList: code.codeList,
        code : code.code,          
        description : code.description
     
      },
      validationSchema: Yup.object({
  
      }),
      onSubmit: (values) => {           
          save('company/saveCompanyCode',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('general.label.code')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div className="col-12">
                              <div className="form-group">
                                <label>{t('general.label.codeList')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=> { codeList==='' ? formik.setFieldValue('codeList',value.value) : formik.setFieldValue('codeList',codeList)}}
                                      value={formik.values.codeList}
                                      options={codeListOptions}                                        
                                      
                                />                                
                              </div>                             
                          </div>         

                         <div className="row"> 
                                <div className="col-12">
                                  <div className="form-group">
                                    <label>{t('general.label.code')}</label>
                                    <input type="text" class="form-control" placeholder="" {...formik.getFieldProps('code')} />
                                  </div>
                                  {formik.touched.code && formik.errors.code ? (
                                    <div style={{ color: 'red' }}>{formik.errors.code}</div>
                                ) : null} 
                                </div>        
                          </div>                        
                           

                          <div className="row">
                               

                                <div className="col-12 col-sm-12 col-lg-12">
                                     <div className="form-group">
                                       <label>{t('general.label.description')}</label>
                                       <input type="text" className="form-control" {...formik.getFieldProps('description')} />                                   
                                     </div>
                                </div>
                          </div>
                           

                    </Modal.Body>
                    <Modal.Footer>                          
                          <Button style={selectedRecord ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
           </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 

     
      </>
    );
  };

 export default CodeModal;